import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-446b6613"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table table-striped mb-0 table-width-auto text-nowrap text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "类型", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "角色名称", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "normal-width text-left" }, "角色说明", -1))
const _hoisted_5 = { class: "text-left" }

export function render(_ctx, _cache) {
  const _component_app_checkbox = _resolveComponent("app-checkbox")
  const _component_app_modal = _resolveComponent("app-modal")

  return (_openBlock(), _createBlock(_component_app_modal, {
    ref: "selectRoleModal",
    title: _ctx.title,
    size: "lg",
    noPadding: true,
    submitFunction: _ctx.submitFunction
  }, {
    default: _withCtx(() => [
      _createElementVNode("table", _hoisted_1, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, [
              _createVNode(_component_app_checkbox, { type: "custom" })
            ]),
            _hoisted_2,
            _hoisted_3,
            _hoisted_4
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleItems.roleList, (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, [
                _createVNode(_component_app_checkbox, {
                  type: "custom",
                  modelValue: _ctx.roleItems.roleSelected[item.roleId],
                  "onUpdate:modelValue": $event => ((_ctx.roleItems.roleSelected[item.roleId]) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("td", null, _toDisplayString(item.orgTypeIdName), 1),
              _createElementVNode("td", null, _toDisplayString(item.roleName), 1),
              _createElementVNode("td", _hoisted_5, _toDisplayString(item.roleRemark), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "submitFunction"]))
}